import React from 'react'

import {createLargeSvgIcon} from './utils'
import {css} from '../theme/css'

const className = css`
  fill: none;
`

export default createLargeSvgIcon(
  <>
    <g clip-path="url(#clip0_3537_168877)">
      <rect width="40" height="40" fill="#F8F7F3" />
      <path
        d="M27.5 4C28.3 3.2 32.1667 0 34 -1.5H38.5C37.8333 0 36.6 3.1 37 3.5C37.4 3.9 41.1667 2.66667 43 2V9H36C35 9 35 8 34.5 7.5C34 7 23 9.5 23 9C23 8.5 26.5 5 27.5 4Z"
        fill="#E6F1E3"
      />
      <path
        d="M23.5 19.5L41 15V42H24C23.6667 41.8333 23.2 41.3 24 40.5C25 39.5 38 36.5 38 36C38 35.5 34 34.5 32.5 34C31 33.5 26 33 25.5 32C25.1 31.2 23.3333 24 22.5 20.5L23.5 19.5Z"
        fill="#E6F1E3"
      />
      <path
        d="M47.5 9V13.5H36C36.0083 13.5 35.9807 13.4996 35.9092 13.5117C35.8394 13.5235 35.7443 13.5447 35.6221 13.5791C35.3746 13.6487 35.0639 13.7593 34.6924 13.915C33.9476 14.2272 33.0664 14.6733 32.1289 15.1895C30.2423 16.2282 28.3329 17.4327 27.0293 18.2148C25.8884 18.8994 20.5 23.5 18.3398 25.2559C16.1797 27.0117 14 28.5 12.5 29.5C11 30.5 8.80643 31.3331 7.89453 31.7891C6.49888 32.4869 3.62879 33.3723 1.10352 34.1182C-1.5872 34.9128 -3.9766 35.5745 -4.81641 35.8799L-6.18359 32.1201C-5.19017 31.7589 -2.52995 31.0208 -0.0292969 30.2822C2.63709 29.4947 5.10112 28.7131 6.10547 28.2109C6.69356 27.9169 8.74088 27.2417 10.5 26C12.2075 24.7947 14.4698 22.9992 16.5 21.5C20.4761 18.5638 23.6113 15.6009 24.9707 14.7852C26.1671 14.0673 28.2274 12.7717 30.2002 11.6855C31.1923 11.1393 32.0673 10.3909 33 10C33.8585 9.64019 35.0525 9 36 9H47.5Z"
        fill="#DEEAF3"
      />
      <path
        d="M6 36.5002C4 36.1002 0.5 36.3335 -1 36.5002V42.1953H11.5V40C11.5 38.5 8.5 37.0002 6 36.5002Z"
        fill="#E6F1E3"
      />
      <path
        d="M32.5 -1C32.6667 0.333333 33.1 3.3 33.5 4.5C33.9 5.7 34.6667 8 35 9M43 8.5C41.5 8.5 40.5 8.5 37 8.5C33.5 8.5 28.8813 12.2712 26 14C23.5 15.5 21.1667 17.3333 19 19C17 20.8333 12.8 24.6 12 25C11 25.5 4.5 29 3 29C1.8 29 -0.166667 28 -1 27.5"
        stroke="#DFDEC8"
        stroke-width="1.2"
      />
      <path
        d="M45 30.9996C43.1667 30.3329 36.5 28.5 32 27.9996C29.2172 27.6901 24.5 28.1663 22.5 28.4996"
        stroke="#DFDEC8"
        stroke-width="1.2"
      />
      <path
        d="M-0.5 44.5C4.83333 40.5 16.9 31.7 22.5 28.5C28.1 25.3 40.1667 19.8333 45.5 17.5"
        stroke="#DFDEC8"
        stroke-width="1.2"
      />
      <path
        d="M23.5 -2.5C20 -1.16667 15.5 0.5 10 3C6.94654 4.38794 4 6 2 5.5C0.4 5.1 -2.5 3.16667 -4 2"
        stroke="#DFDEC8"
        stroke-width="1.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_3537_168877">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </>,
  'MapBackground',
  {className}
)
